<p style="text-align: right; cursor: pointer;" (click)="dismiss()">Close</p>
    <span class="example-pizza-party" *ngFor="let error of errors">
        {{ error }}<br>
    </span>